import ButtonGoogleAction from "../components/Buttons/ButtonGoogleAction";
import ButtonLinkedinAction from "../components/Buttons/ButtonLinkedinAction";
import ButtonMetaAction from "../components/Buttons/ButtonMetaAction";
import ButtonTikTokBusinessAction from "../components/Buttons/ButtonTikTokBusinessAction";
import ButtonTikTokAction from "../components/Buttons/ButtonTikTokAction";
import ButtonCanvaAction from "../components/Buttons/ButtonCanvaAction";
import ButtonYouTubeAction from "../components/Buttons/ButtonYouTubeAction";
import {
  GOOGLE,
  LINKEDIN,
  META,
  TIKTOK,
  CANVA,
  YOUTUBE,
} from "../utils/constants";

const useButtonActionPlatform = (useBusiness = true) => {
  const BUTTON_ACTIONS_COMPONENTS = {
    [META]: <ButtonMetaAction />,
    [TIKTOK]: useBusiness ? (
      <ButtonTikTokBusinessAction />
    ) : (
      <ButtonTikTokAction />
    ),
    [GOOGLE]: <ButtonGoogleAction />,
    [LINKEDIN]: <ButtonLinkedinAction />,
    [CANVA]: <ButtonCanvaAction />,
    [YOUTUBE]: <ButtonYouTubeAction />,
  };

  return BUTTON_ACTIONS_COMPONENTS;
};

export default useButtonActionPlatform;
